/**
 * 定数定義
 * @module KokosilConfig
 */

/**
 * サイトタイトル
 * @static
 * @const {string}
 */
const PAGE_TITLE=process.env.REACT_APP_PAGE_TITLE || "ココシル施設検索";

/**
 * 対象のココシルのサイト識別ラベル（ginza, ueno など）
 * @static
 * @const {string}
 */
const KOKOSIL_SITE_LABEL=process.env.REACT_APP_KOKOSIL_SITE_LABEL;
if (KOKOSIL_SITE_LABEL===undefined) {
  alert("ERROR: no KOKOSIL_SITE_LABEL");
}

/**
 * 対象のココシルサイトのトップURL
 * @static
 * @const {string}
 */
const KOKOSIL_TOP=process.env.REACT_APP_KOKOSIL_TOP;
if (KOKOSIL_TOP===undefined) {
  alert("ERROR: no KOKOSIL_TOP");
}


/**
 * 対象のココシルAPIのトップURL
 * @static
 * @const {string}
 */
const KOKOSIL_API = KOKOSIL_TOP + "/api/v3";

/**
 * 一度の検索で取得するスポット数
 * @static
 * @const {integer}
 * @default 48
 */
const KOKOSIL_SPOTS_LIMIT = process.env.REACT_APP_KOKOSIL_SPOT_LIMIT || 48;

/**
 * 場所や地図を別タブで開くときの target
 * @static
 * @const {string}
 */
const KOKOSIL_TAB_TARGET = process.env.REACT_APP_KOKOSIL_TAB_TARGET || KOKOSIL_SITE_LABEL;


/**
 * Google Maps API Key
 * @static
 * @const {string}
 */
const GOOGLE_MAPS_APIKEY = process.env.REACT_APP_GOOGLE_MAPS_APIKEY;
if (GOOGLE_MAPS_APIKEY===undefined) {
  alert("ERROR: no GOOGLE_MAPS_APIKEY");
}


/**
 * 地図の初期中心経度
 * @static
 */
const MAP_DEFAULT_CENTER = {
  lat: parseFloat(process.env.REACT_APP_MAP_DEFAULT_LAT) || 138,
  lng: parseFloat(process.env.REACT_APP_MAP_DEFAULT_LNG) || 38
};

/**
 * 地図の初期ズーム
 * @static
 * @const {number}
 */
const MAP_DEFAULT_ZOOM = parseInt(process.env.REACT_APP_MAP_DEFAULT_ZOOM) || 5;

/**
 * 地図の最小ズーム
 * @static
 * @const {number}
 */
const MAP_MIN_ZOOM = parseInt(process.env.REACT_APP_MAP_MIN_ZOOM) || 1;

/**
 * カテゴリ一覧取得の検索パラメータ
 * @static
 * @const {string}
 */
const CATEGORY_API_PARAMS = process.env.REACT_APP_CATEGORY_API_PARAMS || "";

/**
 * 表示するLV1カテゴリ（nullでない場合は、これら以外は非表示になる）
 * @static
 * @default null
 * @const {array(number)}
 */
const CATEGORY_LV1 = process.env.REACT_APP_CATEGORY_LV1 ? process.env.REACT_APP_CATEGORY_LV1.split(",").map(x => parseInt(x)) : null;

/**
 * 最初から開いておくLV1カテゴリ
 * @static
 * default []
 * @const {array(number)}
 */
const CATEGORY_LV1_OPEN = process.env.REACT_APP_CATEGORY_LV1_OPEN ? process.env.REACT_APP_CATEGORY_LV1_OPEN.split(",").map(x => parseInt(x)) : [];

/**
 * カテゴリ未指定の場合のデフォルト検索対象カテゴリ
 * @static
 * @default ""
 * @const {array(number)}
 */
// AND検索の場合
//const CATEGORY_DEFAULT_SEARCH = process.env.REACT_APP_CATEGORY_DEFAULT_SEARCH ? process.env.REACT_APP_CATEGORY_DEFAULT_SEARCH.split(",").map(i => "category2=" + i).join("&") : null;
// OR検索の場合
const CATEGORY_DEFAULT_SEARCH = process.env.REACT_APP_CATEGORY_DEFAULT_SEARCH ? "category2=" + process.env.REACT_APP_CATEGORY_DEFAULT_SEARCH.split(",").join("+") : null;

/**
 * LV1カテゴリでの折り畳みトグルの無効化
 * @static
 * @default false
 * @const {boolean}
 */
const CATEGORY_NO_LV1_TOGGLE = process.env.REACT_APP_CATEGORY_NO_LV1_TOGGLE === "true" ? true : false;

/**
 * LV2以下を折りたたんだ場合に非表示にするか否か
 * @static
 * @default true
 * @const {boolean}
 */
const CATEGORY_HIDE_DISABLED = process.env.REACT_APP_CATEGORY_HIDE_DISABLED === "false" ? false : true;

export {
  PAGE_TITLE,
  KOKOSIL_SITE_LABEL,
  KOKOSIL_TOP,
  KOKOSIL_API,
  KOKOSIL_SPOTS_LIMIT,
  KOKOSIL_TAB_TARGET,
  GOOGLE_MAPS_APIKEY,
  MAP_DEFAULT_CENTER,
  MAP_DEFAULT_ZOOM,
  MAP_MIN_ZOOM,
  CATEGORY_API_PARAMS,
  CATEGORY_LV1,
  CATEGORY_LV1_OPEN,
  CATEGORY_DEFAULT_SEARCH,
  CATEGORY_NO_LV1_TOGGLE,
  CATEGORY_HIDE_DISABLED
};
